<template>
        <div class="comment-item" :class="answerVisible ? 'visible-answers' : ''">
            <a href="" class="avatar">
                <img :src="comment.image" alt=""/>
            </a>
            <div class="comment has-controls">
                <div class="data">
                    <p class="author">{{comment.author}}</p>
                    <time :datetime="comment.date" class="time"><span v-if="comment.updated !== comment.created">Отредактировано </span>{{comment.date}}</time>
                    <div class="comment-controls" v-show="!action">
                        <span v-if="comment.canEdit" title="Редактировать комментарий" class="js-edit-comment" @click="editClick">
                            <icon-base width="13" height="13" viewBox="0 0 17 17" icon-name="Редактировать комментарий"><icon-pencil/></icon-base>
                        </span>
                        <span v-if="comment.canDelete" title="Удалить комментарий" class="js-delete-comment" @click="deleteComment">
                            <icon-base width="10" height="13" viewBox="0 0 10 13" icon-name="Удалить комментарий"><icon-bin/></icon-base>
                        </span>
                    </div>
                </div>
                <p v-show="action !== EDIT_COMMENT">
                    <span v-if="comment.target" class="for">@{{getCommentTarget(comment.target)}}</span> {{comment.text}}
                </p>

                <div v-show="!action" class="answer-controls">
                    <span v-show="!action && canAnswer" class="js-answer-comment" @click="action = SEND_COMMENT">Ответить</span>
                    <span v-if="children.length" :class="'js-show-comment-answers' + (answerVisible ? ' opened' : '')"
                          :title="answerVisible ? 'Скрыть ответы' : 'Показать ответы'" @click="answerVisible = !answerVisible"></span>
                </div>
                <dropdown-item-component :visible="!!children.length && answerVisible">
                    <post-comments :comments="children" :answer="true" :can-answer="canAnswer"></post-comments>
                </dropdown-item-component>
            </div>
            <comment-form v-if="action"
                          :comment="comment"
                          :action="action"
                          :cancelBtn="true"
                          :parent="getParentId"
                          :target="comment.id"
                          @cancel="action=0"
            ></comment-form>

        </div>
</template>

<script>
    import DropdownItemComponent from "../common/Dropdown";
    import CommentForm from "./CommentForm"
    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import IconBase from "../common/IconBase";
    import IconPencil from "../common/icons/IconPencil";
    import IconBin from "../common/icons/IconBin";
    import ConfirmComponent from "../common/ConfirmComponent";

    import {SEND_COMMENT, EDIT_COMMENT} from "../../constants/common";

    export default {
        name: 'post-comment',
        components: {
            IconBase,
            IconBin,
            IconPencil,
            DropdownItemComponent,
            CommentForm,
        },
        data() {
            return {
                answerVisible: true,
                action: 0,
                SEND_COMMENT: SEND_COMMENT,
                EDIT_COMMENT: EDIT_COMMENT
            }
        },
        props: {
            comment : Object,
            children: Array,
            canAnswer: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            getParentId() {
                if (this.comment.parent > 0) {
                    return this.comment.parent
                } else {
                    return this.comment.id
                }
            },
            ...mapGetters('knowledge', [
                'getCommentTarget'
            ])

        },
        methods: {
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
                'setConfirmAction',
            ]),
            deleteComment() {
                this.setConfirmAction({action: 'knowledge/deleteComment', payload: this.comment.id, text: 'Удалить комментарий?'});
                this.setPopupComponent(ConfirmComponent);
                this.switchPopup();
            },
            editClick() {
                this.action = EDIT_COMMENT;
            }

        }
    }

</script>

<style scoped>

</style>
